import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema, useTheme } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import {useLocation} from "react-router-dom";

/*
 *  Access Statistics Services
 * !== 접속 통계 서비스 ==!
 */
export const BASE = {
    path: `${ptlEnvs.base}/ststcl/acss`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/ststcl/acss`,
    nodes: [],
};

export const URLS = {
    ptli1011001q: `${BASE.path}/ptli1011001q`, // Access Statistics List !==  접속 통계 목록 ==!
    ptli1011002q: `${BASE.path}/ptli1011002q`, // Access Statistics information details !==  접속 통계 정보 상세 ==!
};

export const APIS = {
    // Get a list of Access Statistics !== 접속 통계 목록 조회==!
    getAcssStstclList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) });
    },
    // Get a list of Access Statistics details !== 접속 통계 상세목록 조회==!
    // getAcssStstclDtlList: (data: any, page: number, size: number) => {
    //     console.log(`${BASE.api}/${data.acssDt}/${data.acssMenuId}?page=${page}&size=${size}`);
    //     return api.get(`${BASE.api}/${data.acssDt}/${data.acssMenuId}?page=${page}&size=${size}`, {});
    // },

    getAcssStstclDtlList: (data: any, page: number, size: number) => {
        const { acssDt, acssMenuId, usrId } = data;

        // Builds the URL query parameters for pagination and optionally includes the usrId.
        // to fetch only the intended usrId
        const queryParams = new URLSearchParams();
        queryParams.set("page", String(page));
        queryParams.set("size", String(size));
        if (usrId) {
            queryParams.set("usrId", usrId);
        }

        const url = `${BASE.api}/${acssDt}/${acssMenuId}?${queryParams.toString()}`;
        console.log("Calling URL:", url);

        return api.get(url, {});
    },

};

export const SF_ACSS_SRCH: TFormSchema = {
    id: "form_acssSrch",
    schema: {
        usrId: { type: "text", label: "L_USR_ID" },
        ptlTpCd: { type: "select", label: "L_PTL_TP_CD", area: "comnCd", comnCd: "COM0052", excludes: ["B"] },
        acssDt: {
            type: "daterange",
            label: "L_ACSS_PRID",
            start: { name: "acssDtStrt", required: true },
            end: {
                name: "acssDtEnd",
                validate: (value: any, formValues: any) => {
                    // 종료일자와 시작일자를 비교하여 오류검증 실행
                    // formValues.startDate 처럼 시작일자(startDate) 필드를 지정해서 비교
                    return comnUtils.dateDiff(value, formValues.acssDtStrt) < 0 ? "msg.cgm.00034" : true;
                },
                required: true,
            },
            rangeButton: 0,
            required: true,
        },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "COM0024",
            editType: "both",
            excludes: ["COM", "EWC", "TDW", "TDA"],
        },
        usrDmnId: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "COM0024",
        },
    },
};

export const SG_ACSS_LIST: TGridSchema = {
    id: "grid_acssList",
    options: { pagination: "out", edit: false },
    head: [
        { cells: [{ header: "L_ACSS_DT", binding: "acssDt", width: "8%" }] },
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "8%" }] },
        { cells: [{ header: "L_MENU_NM", binding: "menuNm", width: "*" }] },
        { cells: [{ header: "L_MENU_ID", binding: "menuId", width: "*" }], show: false },
        { cells: [{ header: "L_ACSS_CNT", binding: "acssCnt", width: "10%" }] },
    ],
    body: [
        { cells: [{ binding: "acssDt", type: "date" }] },
        { cells: [{ binding: "bsopClsfCd", align: "center" }] },
        { cells: [{ binding: "menuNm", align: "left" }] },
        { cells: [{ binding: "menuId", align: "left" }] },
        { cells: [{ binding: "acssCnt", align: "right" }] },
    ],
};

export const SF_ACSS_DTL_SRCH: TFormSchema = {
    id: "form_acssDtlSrch",
    schema: {
        menuId: { type: "text" },
    },
};

export const SG_ACSS_DTL_LIST: TGridSchema = {
    id: "grid_acssDtlList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_USR_DMN_ID", binding: "usrDmnId", width: "10%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "10%" }] },
        { cells: [{ header: "L_MENU_NM", binding: "menuNm", width: "20%" }] },
        { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: "20%" }] },
        { cells: [{ header: "L_ACSS_DTM", binding: "acssDtm", width: "15%" }] },
        { cells: [{ header: "L_RQST_URL_ADDR", binding: "rqstUrlAddr", width: "25%" }] },
        { cells: [{ header: "L_USR_IP_ADDR", binding: "usrIpAddr", width: "10%" }] },
    ],
    body: [
        { cells: [{ binding: "usrDmnId" }] },
        { cells: [{ binding: "usrNm" }] },
        { cells: [{ binding: "menuNm", type: "text", align: "left" }] },
        { cells: [{ binding: "scrnNm", type: "text", align: "left" }] },
        { cells: [{ binding: "acssDtm", type: "datetime" }] },
        { cells: [{ binding: "rqstUrlAddr", type: "text", align: "left" }] },
        { cells: [{ binding: "usrIpAddr", type: "text", align: "left" }] },
    ],
};
